import React, {useState,useMemo} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import CopyToClipboard from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip';

import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';import CheckBoxIcon from '@mui/icons-material/CheckBox';
//import LaunchIcon from '@mui/icons-material/Launch';
//import MessageIcon from '@mui/icons-material/Assignment';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Inc,Owner,Secret,SaleSearchCondition} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Loading from './Loading';
import Alert from './Alert';
import Yesno from './Yesno';
import Toast from './Toast';
import SecretListSearch from './SecretListSearch';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Title from './Title';
import AppBank from './AppBank';

interface SecretListProps {
	owner:Owner,
	bank:AppBank,
}
//let p:number = 1;

const SecretList = (props:SecretListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defSecrets:Secret[] = [];
	const defCheckedIds:number[] = [];

	const [states,setStates] = useState({
        secrets:defSecrets,
		secretId:0,
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
		currentPage:1,
        pager:null,
		yesno:"",
		alert:"",
		ver:0,
        cond:Inc.defaultSaleSearchCondition(),
    });
	const [toast,setToast] = useState('');
    const search = (cond:SaleSearchCondition,page:number)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
        // if( first ){
        //     p = 1;
        // }
        window.scrollTo(0,0);
        Ajax.search("secret/list",cond,page,(res:any)=>{
			//console.log(res);
            if( res.ok ){
                setStates({...states,secrets:res.secrets,cond:cond,currentPage:page,pager:res.pager,isLoading:false,checkedIds:defCheckedIds,allChecked:false,yesno:""});
            } else {
                setStates({...states,"isLoading":false});
            }
        });
    }
	const jump = (newPage:number)=>{
		//send(values,p);
		//p = newPage;
		search(states.cond,newPage);
    }
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids,ver:states.ver+1});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id),ver:states.ver+1});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false,ver:states.ver+1});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.secrets.length ; i++ ){
				if(states.secrets[i].status==="1") {
					ids.push( states.secrets[i].secret_id );
				}
			}
			setStates({...states,"checkedIds":ids,"allChecked":true,ver:states.ver+1});
		}
	}
	const yes = ()=>{
		if( states.yesno==="remove" ){
			Ajax.send("secret/remove",{secret_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
		if( states.yesno==="pause" || states.yesno==="play" ){
			Ajax.send("secret/toggle",{secret_id:states.secretId},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
		if( states.yesno==="removeone" ){
			Ajax.send("secret/removeone",{secret_id:states.secretId},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	const copyUrl = ()=>{
		setToast('クリップボードにURLをコピーしました');
	}
	const closeToast = ()=>{
		setToast('');
	}
	const copyAnswer = ()=>{
		setToast('クリップボードにパスワードをコピーしました');
	}
	const confirmRemove = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"シークレットを選択して下さい"});
		} else {
			setStates({...states,"yesno":"remove"});
		}
	}
	const confirmPause = (secretId:number)=>{
		//console.log( states.checkedIds );
		setStates({...states,"yesno":"pause",secretId:secretId});
	}
	const confirmPlay = (secretId:number)=>{
		setStates({...states,"yesno":"play",secretId:secretId});
	}
	const confirmRemoveOne = (secretId:number)=>{
		setStates({...states,"yesno":"removeone",secretId:secretId});
	}
	const SecretRow = (pr:{secret:Secret,owner_id:number,index:number})=>{
		const [rowstate,setRowstate] = useState({open:false});
		const toggle = async ()=>{
			setRowstate({...rowstate,open:!rowstate.open});
		}
		let status = "販売中";
		if(pr.secret.status==="0"){
			status = "休止中";
		}
		const v = states.checkedIds.includes(pr.secret.secret_id);
		const url = 'https://store.retro-biz.com/items/'+pr.secret.item_id;

		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellDense} style={{width:'2em'}}>
					<Checkbox
						checked={v}
						value={String(pr.secret.secret_id)}
						onClick={()=>checkId(pr.secret.secret_id)}
						color="primary"
						className={classes.listCheckbox}
					/>
				</TableCell>
				<TableCell className={classes.tableCellDense} align="center" style={{width:'80px'}} sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}><StoreImg owner_id={props.owner.owner_id} img_id={pr.secret.img_id} thumb={true} className="imgList"/></TableCell>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{pr.secret.item_id}</span><br/>
					{pr.secret.item_name}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right" style={{width:'5em'}} sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>{pr.secret.su}{pr.secret.unit}</TableCell>
				<TableCell className={classes.tableCellNowrap} align="center" style={{width:'5em'}} sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>{Tools.colorLabel("secret_status",pr.secret.status,status)}</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right" style={{width:'2em'}}><IconButton style={{margin:'0',padding:'0'}} onClick={toggle}><ArrowDropDownIcon/></IconButton></TableCell>
			</TableRow>
			{rowstate.open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '3em', paddingTop: 0, paddingLeft: '0em', paddingRight: 0}} colSpan={9}>
					<Table>
						<TableBody>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									メッセージ
								</TableCell>
								<TableCell>
									{Tools.empty(pr.secret.question)}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									パスワード
								</TableCell>
								<TableCell>
									{pr.secret.answer}
									<CopyToClipboard text={pr.secret.answer} onCopy={copyAnswer}><Tooltip title="パスワードをコピーする"><IconButton color="primary" size="small"><ContentPasteIcon/></IconButton></Tooltip></CopyToClipboard>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									販売ページ
								</TableCell>
								<TableCell>
									<a href={url} rel="noreferrer noopener" target="_blank">{url}</a>
									<CopyToClipboard text={url} onCopy={copyUrl}><Tooltip title="販売ページのURLをコピーする"><IconButton color="primary" size="small"><ContentPasteIcon/></IconButton></Tooltip></CopyToClipboard>
								</TableCell>
							</TableRow>
							<TableRow sx={{display:{lg:'none',md:'none',sm:'none',xs:'table-row'}}}>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									在庫数
								</TableCell>
								<TableCell>
									{pr.secret.su}{pr.secret.unit}
								</TableCell>
							</TableRow>
							<TableRow sx={{display:{lg:'none',md:'none',sm:'none',xs:'table-row'}}}>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									状態
								</TableCell>
								<TableCell>
									{Tools.colorLabel("secret_status",pr.secret.status,status)}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'25%',md:'20%'}}}>
									登録日時
								</TableCell>
								<TableCell>
									{pr.secret.created}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					<Box sx={{ marginTop:'0.5em', display: 'flex',justifyContent: 'space-between' }}>
						<Button variant="text" size="small" color="error" onClick={()=>confirmRemoveOne(pr.secret.secret_id)}><DeleteForeverIcon/>削除</Button>
						{pr.secret.status==='1' ? (
						<Button variant="outlined" size="small" color="info" onClick={()=>confirmPause(pr.secret.secret_id)}><PauseCircleIcon/>一時休止</Button>
						):(
						<Button variant="outlined" size="small" color="primary" onClick={()=>confirmPlay(pr.secret.secret_id)}><PlayCircleIcon/>販売再開</Button>
						)}
					</Box>
				</TableCell>
			</TableRow>
			}
			</>
		);
	}

	const secretRows = useMemo(()=>{
		return states.secrets.map((secret:Secret,index:number)=>{
			const key = "consign"+index;
			return <SecretRow secret={secret} owner_id={props.owner.owner_id} index={index} key={key}/>
		})
	},[states.secrets,states.ver])


	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択したシークレットを削除して商品を「非公開」にします。\nよろしいですか？";
		}
		if( states.yesno==="pause" ){
			yesnoMes = "このシークレットを「一時休止」にします。\n正しいパスワードを入力すると商品の閲覧はできますが購入はできません。\n\nよろしいですか？";
		}
		if( states.yesno==="play" ){
			yesnoMes = "このシークレットを再開します。\n正しいパスワードを入力すると商品の閲覧も購入もできます。\n\nよろしいですか？";
		}
		if( states.yesno==="removeone" ){
			yesnoMes = "このシークレットを削除して商品を「非公開」にします。\nよろしいですか？";
		}
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

    return (
		<div id="secret_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="シークレット（パスワード販売）" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                            シークレットは商品ページにパスワードをかける機能です。正しいパスワードを入力したお客様だけが商品を閲覧・購入できます。<br/>
                            新たにパスワードを登録するには、「シークレットを登録」をクリックして下さい。<br/>
							<div className={classes.hintList}>
								※パスワードのかかった商品は商品検索に表示されなくなりますので、パスワードと一緒に販売ページのURLをお客様にお知らせする必要があります。
							</div>
							<Hidden mdUp implementation="js">
								<FormControl fullWidth={true} style={{margin:"1em 0", display: "flex", alignItems: "flex-end"}}>
									<Link to="/secret/input"><Button variant="contained" color="primary" style={{whiteSpace:"nowrap"}}><AddIcon/>シークレットを登録</Button></Link>
								</FormControl>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>
									</TableCell>

                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>画像</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">商品名</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>在庫</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'table-cell',sm:'table-cell',xs:'none'}}}>状態</TableCell>
									<TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
							<TableBody>{secretRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・削除" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Link to="/secret/input"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>シークレットを登録</Button></Link>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックしたシークレットを</div>
							<Button variant="contained" color="secondary" size="small" onClick={confirmRemove} disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
						</FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>シークレットを削除すると商品は「非公開」の状態表示になります。再度公開するには発売日またはシークレットを登録してください。</li>
                        </ul>
						<div style={{textAlign:'right'}}>
							<Link to="/help/secret/119"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>シークレットとは</Button></Link>
							<Link to="/help/sale/127"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>状態表示とは</Button></Link>
						</div>
					</Paper>

                    <Paper className={classes.paper}>
                        <SecretListSearch update={search} bank={props.bank} bankKey={"savedSecretListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default SecretList;
